export class CountResponse {
  /**
   * @param {!number} count
   */
  constructor(count) {
    this.count = count;
  }
}
